module.exports = __webpack_public_path__ + "static/media/winex5.dfe7f8ee.jpg";